import { Suspense, lazy } from 'react'
import { Navigate, Route, Routes } from 'react-router-dom'

import LoadingSpinner from '@/components/LoadingSpinner'

// Lazy load components
const Framework = lazy(
  async () => import('@/pages/getRecipe/fullLayering/framework'),
)

const WashBake = lazy(
  async () => import('@/pages/getRecipe/fullLayering/newWashbake'),
)
const Dentin = lazy(async () => import('@/pages/getRecipe/fullLayering/dentin'))
const InternalEffects = lazy(
  async () => import('@/pages/getRecipe/fullLayering/internalEffects'),
)
const Enamel = lazy(async () => import('@/pages/getRecipe/fullLayering/enamel'))
const StainingCorrections = lazy(
  async () => import('@/pages/getRecipe/fullLayering/stainingCorrection'),
)

const FullLayeringRoutes: React.FC = () => {
  return (
    <Suspense fallback={<LoadingSpinner />}>
      <Routes>
        <Route path="framework" element={<Framework />} />
        <Route path="wash-bake" element={<WashBake />} />
        <Route path="dentin" element={<Dentin />} />
        <Route path="internal-effects" element={<InternalEffects />} />
        <Route path="enamel" element={<Enamel />} />
        <Route path="staining-corrections" element={<StainingCorrections />} />
        <Route path="" element={<Navigate to="framework" replace={true} />} />
      </Routes>
    </Suspense>
  )
}

export default FullLayeringRoutes
